<template>
  <PageHeader></PageHeader>
</template>

<script>
import PageHeader from './PageHeader'
export default {
  name: 'Logs',
  data () {
    return {
    }
  },
  mounted(){
  },
  components: {
    PageHeader
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Logs.vue